export default {
      id: "star-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.85006585.svg#star",
      toString: function () {
        return this.url;
      }
    }